// extracted by mini-css-extract-plugin
export default {"container":"cTEfjq72","footer":"wBKlcJee","img":"XOOlJYr4"};